export enum HelpdeskView {
  HelpdeskHome = "HelpdeskHome",
  HelpdeskList = "HelpdeskList",
  CreateTicket = "CreateTicket",
  TicketDetails = "TicketDetails",
}
